import axios from "axios"
import { API_URL } from "./ApiURL"

export const UserLogin = async (body) => {
  const { data } = await axios.post(`${API_URL}login/loginpasscode`, body, {
    timeout: 20000,
  })
  return data
}
